<template>
  <span></span>
</template>

<script>
  import setInputValue from "../utils/setInputValue";
  import config from '../../../../config/config.json';
  import axios from 'axios';

  const domain = config.dashboard.domain;
  const serverId = config.server.id;

  const getRandomValue = (arr) => {
    return arr[ Math.floor(Math.random() * arr.length) ];
  }

  export default {
    props: {
      target: {default: ''},
      trial: {default: ''},
      values: {default: ''},
      submitOnReady: {default: false}
    },
    data () {
      return {}
    },
    computed: {
      $values () {
        return this.values.split(',')
          .map(n => parseInt(n))
          .filter(n => n);
      }
    },
    mounted () {
      if (this.submitOnReady)
        $('#movenextbtn').hide();

      axios
        .post(domain + '/app/round-robin', {
          serverId,
          trialId: this.trial,
          target: this.target,
          values: this.$values,
        })
        .then(response => {
          console.log({response: response.data});
          if (response && response.data && response.data.value) {
            setInputValue(this.target, response.data.value);
          } else {
            setInputValue(this.target, getRandomValue(this.$values));
          }
          if (this.submitOnReady)
            this.submitPage();
        })
        .catch(e => {
          setInputValue(this.target, getRandomValue(this.$values));
          if (this.submitOnReady)
            this.submitPage();
        });
    },
    methods: {
      submitPage () {
        $('#movenextbtn')
          .removeClass('active')
          .removeClass('disabled')
          // .show()
          .click()
      }
    }
  }
</script>
